import { BASE_PRESET_NAME } from "building-types/doc/docDefaultConstants";
import { type Preset } from "building-types/options/preset";

export function newPresetInt(biggestN: number, preset: Preset) {
  const words = preset.name.toLowerCase().split(" ");
  if (words.length > 1) {
    const first = words[0];
    const final = words[words.length - 1];

    if (first === "preset" && /^[1-9]\d*$/.test(final)) {
      const n = parseInt(final, 10);
      if (n >= biggestN) {
        biggestN = n + 1;
      }
    }
  }
  return biggestN;
}

export function presetIsBasePreset(preset: Preset) {
  return isBasePresetId(preset.id);
}

export function isBasePresetId(presetId: string) {
  return presetId === BASE_PRESET_NAME;
}
